"use strict";
/**
 * Contraste WCAG 2.1 — F-SOC-14.
 *
 * Le système de composants dit que chaque couple de couleurs « a été mesuré,
 * pas estimé ». Ce module est ce qui rend la phrase vraie : les ratios ne sont
 * plus recopiés d'un tableur, ils sont recalculés à chaque construction.
 *
 * La formule est celle de WCAG 2.1, appliquée telle quelle — pas d'astuce, pas
 * d'approximation par la luminosité perçue. Une valeur fausse ici ne se verrait
 * pas : elle rendrait simplement un jeton illisible au soleil, sur un écran
 * d'entrée de gamme, à un chauffeur qui roule.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RATIO_AAA = exports.RATIO_AA = void 0;
exports.estCouleur = estCouleur;
exports.luminance = luminance;
exports.contraste = contraste;
exports.niveau = niveau;
/** Un canal converti en luminance linéaire, selon la courbe sRGB. */
function canal(valeur) {
    const v = valeur / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
}
function estCouleur(valeur) {
    return /^#[0-9A-Fa-f]{6}$/.test(valeur);
}
function luminance(couleur) {
    if (!estCouleur(couleur))
        throw new Error(`Couleur mal formée : ${couleur}`);
    const n = Number.parseInt(couleur.slice(1), 16);
    const r = canal((n >> 16) & 0xff);
    const v = canal((n >> 8) & 0xff);
    const b = canal(n & 0xff);
    return 0.2126 * r + 0.7152 * v + 0.0722 * b;
}
/** Le ratio de contraste entre deux couleurs, de 1 à 21. */
function contraste(premier, second) {
    const a = luminance(premier);
    const b = luminance(second);
    const clair = Math.max(a, b);
    const sombre = Math.min(a, b);
    return (clair + 0.05) / (sombre + 0.05);
}
/** Seuils WCAG pour du texte de taille courante. */
exports.RATIO_AA = 4.5;
exports.RATIO_AAA = 7;
function niveau(ratio) {
    if (ratio >= exports.RATIO_AAA)
        return 'AAA';
    if (ratio >= exports.RATIO_AA)
        return 'AA';
    return 'insuffisant';
}
//# sourceMappingURL=contraste.js.map